import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface MessageDialogData {
  errorDialog?: boolean;
  infoDialog?: boolean;
  status?: string;
  title?: string;
  message?: string;
  btnSim?: string;
  btnNao?: string;
}

@Component({
    selector: 'app-message-dialog',
    templateUrl: './message-dialog.component.html',
    styleUrls: ['./message-dialog.component.scss'],
    standalone: false
})
export class MessageDialogComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: MessageDialogData,
    public dialogRef: MatDialogRef<MessageDialogComponent>
  ) {
    this.data = this.data || {};
  }

  get kind(): 'error' | 'info' | 'quiz' {
    if (this.data.errorDialog) return 'error';
    if (this.data.infoDialog) return 'info';
    return 'quiz';
  }

  close(result?: boolean): void {
    this.dialogRef.close(result);
  }

  /** Mantido por compatibilidade com chamadas antigas do template/pais. */
  closeDialog(): void {
    this.dialogRef.close(false);
  }
}

